const texts = {
  authorizationTabs: { signIn: "Eintragen", signUp: "Anmelden" },
  general: {
    save: "Speichern",
    close: "Schließen",
    next: "Nächstes",
    clearStep: "Diesen Schritt löschen",
    tryAgain: "Erneut versuchen",
    errorTitle: "Fehler",
    service: "Service:",
    message: "Nachricht",
    statusCode: "Statuscode:",
  },
  months: {
    "1": "Januar",
    "2": "Februar",
    "3": "März",
    "4": "April",
    "5": "Mai",
    "6": "Juni",
    "7": "Juli",
    "8": "August",
    "9": "September",
    "10": "Oktober",
    "11": "November",
    "12": "Dezember",
  },
  signIn: {
    title: "Willkommen bei MultiMatch",
    description: "Erstellen Sie Ihre eigene maßgeschneiderte Lösung für Dünger mit verzögerter Freisetzung (CRF)",
    email: "Email",
    password: "Passwort",
    forgotPassword: "Haben Sie Ihren Passwort vergessen?",
    keepMeLoggedIn: "Auf diesem Computer angemeldet bleiben",
    keepMeLoggedInMobile: "Von diesem Gerät aus angemeldet bleiben",
    emailApproved: "Ihre E-Mail wurde genehmigt Bitte melden Sie sich an: um fortzufahren",
  },
  updatePassword: {
    title: "Neues Passwort setzen",
    description: "Ihr Passwort sollte haben",
    password: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    submitMessage: "Passwort erneuern",
    success: "Ihr Passwort hat sich geändert: Sie werden zur Anmeldeseite weitergeleitet.",
    UPDATE_PASSWORD_CONFIRMED: "Ihr Passwort wurde erfolgreich bestätigt",
    errors: {
      EMAIL_TOKEN_INVALID: "Ihr Token zum Zurücksetzen des Passworts ist ungültig",
      EMAIL_NOT_CONFIRMED: "Ihre Email Adresse wurde nicht bestätigt.",
      MAIL_NOT_CONFIRMED: "Ihre Email Adresse wurde nicht bestätigt.",
      PASSWORD_UPDATE_SUCCESS: "Ihr Passwort wurde aktualisiert ",
      PASSWORD_UPDATE_FAILED: "Ihr Passwort konnte nicht aktualisiert werden",
      TEMP: "Ungültiges Token oder Email nicht bestätigt",
    },
    sendEmail: "Wir haben eine Email gesendet\n Gehen Sie in Ihren Posteingang ",
    errorPasswordRequired: "Passwort und Passwort bestätigen dürfen nicht leer sein",
  },
  signUp: {
    note: "Melden Sie sich an: um Ihre Informationen für die zukünftige Verwendung zu speichern",
    passwordNote: "Ihr Passwort sollte mindestens 8 Zeichen lang sein und einen Großbuchstaben: Kleinbuchstaben und eine Zahl enthalten.",
    fullName: "Vollständiger Name",
    country: "Land",
    region: "Region",
    email: "Email",
    mainInterest: "Hauptinteresse",
    expertise: "Fachkenntnisse",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    iAccept: "Ich nehme an",
    termsAndConditions: "Allgemeine Geschäftsbedingungen von Haifa",
    and: "und",
    privacyPolicy: "Datenschutzrichtlinie",
    next: "Nächstes",
    emailSent: "Wir haben eine Email gesendet {0}\n Gehen Sie in Ihren Posteingang",
    didntGet: "Nicht erhalten?",
    checkBoxError: "Bitte genehmigen",
  },
  validationErrors: {
    fieldIsRequired: "Pflichtfelder müssen ausgefüllt werden",
    incorrectEmailFormat: "Email Adresse existiert nicht",
    passwordValidation: "Passwort ist ungültig",
    passwordsDontMatch: "Passwörter stimmen nicht überein",
    lettersOnly: "Bitte nur Buchstaben verwenden",
    incorrectEmail: "Falsche Email Adresse",
    IncorrenctPassword: "Falsches Passwort",
    emailExisted: "Email Adresse existiert bereits im System",
    minimumValue: "Value must be larger than {0}",
    termsCheckbox: "Erfordert",
    valueOutOfRange: "Wert muss zwischen {0} und {1} liegen",
    invalidDateFormat: "Bitte geben Sie ein korrektes Datum an",
    dateMustBeGreater: "Erntedatum muss größer sein als Aussaat",
    dateMustBeAtLeastTwoMonths: "Das Datum muss mindestens zwei Monate betragen",
    noServiceForSpecificCountry: "Für das ausgewählte Land wird kein Service bereitgestellt",
    dateMaxDatesTwelveMonth: "Maximum ist ein Jahr.",
  },
  errorMessages: {
    generic: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut",
    LOGIN_FAILED: "Der Benutzername oder das Passwort ist falsch",
    MISSING_EMAIL: "Email ist erforderlich.",
    EMAIL_INVALID: "Falsche Email Adresse",
    DUPLICATEUSERNAME: "Email Adresse existiert bereits im System",
    PASSWORD_INVALID: "Passwort ist ungültig",
    USERNAME_INVALID: "Name darf keine Sonderzeichen oder Zahlen enthalten",
    SPECIALIZATION_INVALID: "Ungültige Spezialisierung",
    MAIN_INTEREST_INVALID: "Ungültiges Hauptinteresse",
    REGION_INVALID: "Ungültige Region",
    REGION_NOT_EXIST: "Region ist nicht vorhanden",
    USER_NOT_FOUND: "Benutzer existiert nicht",
    USER_ALREADY_EXIST: "Benutzer existiert bereits",
    MISSING_VALUES_TO_CONFIRM_REGISTRATION: "Registrierung fehlgeschlagen - Ihnen fehlen Werte",
    EMAIL_SENT_TO_USER: "Email wurde an Benutzer gesendet",
    REGISTRATION_FAILED: "Registrierung fehlgeschlagen",
    TOKEN_INVALID: "Authentifizierungstoken ungültig",
    EMAIL_CONFIRMED_ALREADY: "Email Adresse wurde bereits bestätigt",
    NO_SOLUTION_MATCH: "Keine fertige Regallösung gefunden",
    EMAIL_CONFIRMED_SUCCESS: "Email wurde erfolgreich bestätigt",
    VALIDATION_FAILED: "Validierung ist fehlgeschlagen",
    ACCEPT_TERMS_INVALID: "Ungültiger Wert zum Akzeptieren der Bedingungen",
    SAVING_ITEM_FAILED: "Element konnte nicht gespeichert werden",
    SAVED_ITEM_NOT_FOUND: "Element ist nicht vorhanden",
    UPDATING_RECIPE_ITEM_FAILED: "Element konnte nicht aktualisiert werden",
    REMOVING_RECIPE_ITEMS_FAILED: "Rezeptelement konnte nicht gelöscht werden",
    REMOVING_GRAPH_ITEMS_FAILED: "Diagrammelement konnte nicht gelöscht werden",
    ITEM_UPDATED_SUCCESSFULLY: "Element wurde erfolgreich aktualisiert",
    ITEM_DELETED_SUCCESSFULLY: "Element wurde erfolgreich gelöscht",
    RAW_MATERIAL_PARAMETERS_NOT_VALID: "Neues Rohmaterial konnte nicht gespeichert werden - Ungültige Parameter",
    SAVING_RAW_MATERIAL_FAILED: "Neues Rohmaterial konnte nicht gespeichert werden",
    RAW_MATERIAL_ALREADY_EXIST: "Rohmaterial existiert bereits",
    REMOVING_ITEM_FAILED: "Element konnte nicht gelöscht werden",
    UPDATING_ITEMS_FAILED: "Fehler beim Aktualisieren des Elements in der Datenbank",
    CALCULATOR_IS_NOT_READY: "Rechnerdaten werden geladen..",
    NUTRIENT_TYPE_INVALID: "Nährstofftyp ungültig",
    BLEND_INVALID: "Ungültige Multicote-Mischung",
    TYPE_INVALID: "Typ ungültig für eine der Eigenschaften",
    MISSING_SAVED_ITEM_ID: "Fehlende gespeicherte Element-ID in Anfrage",
    ITEM_NOT_FOUND: "Element ist nicht gefunden",
    RECIPE_TOTAL_ITEMS_COUNT_IS_MAXIMUM_6: "Rezept kann nicht mehr als 6 Rohstoffe haben",
    RECIPE_HAS_TO_HAVE_MINIMUM_1_COATED_AND_MAXIMUM_5_UNCOATED_MATERIALS:
      "Rezept muss mindestens einen beschichteten Rohstoff und bis zu 5 unbeschichtete Materialien enthalten",
    ONE_OR_MORE_INVALID_MATERIALS_IDS_IN_RECIPE: "Eine oder mehrere ungültige Rohstoff-IDs im Rezept",
    PERCENTAGE_SUM_MUST_BE_100_IN_RECIPE: "Mischungsprozentsatz muss 100 % betragen",
    START_DATE_REQUIRED: "Startdatum erforderlich",
    END_DATE_REQUIRED: "Enddatum erforderlich",
    END_DATE_MUST_BE_GRAETER_THEN_START_DATE: "Enddatum muss größer als Startdatum sein",
    YIELD_VALUE_REQUIRED: "Ertrag erforderlich",
    COUNTRY_INVALID: "Land ungültig",
    CROP_CODE_INVALID: "Ernte ungültig",
    MESUREMENTS_INVALID: "Maßeinheit ungültig",
    SOIL_AND_WATER_COMBINATION_INVALID: "Mischung aus Wasser und Erde ungültig",
    MONTHS_AND_TEMPATURES_INVALID: "Monats- und Temperaturwerte ungültig",
    shareWithNoSaving: "Entschuldigung: ungespeichertes Element kann nicht geteilt werden",
    ITEM_NAME_TOO_SHORT: "Name zu kurz",
    ITEM_RENAME_FAILED: "ARTIKELUMBENENNUNG_FEHLGESCHLAGEN",
    ITEM_DUPLICATE_FAILED: "ARTIKELDUPLIKAT_FEHLGESCHLAGEN",
    UPDATE_PROFILE_FAILED: "PROFIL_AKTUALISIEREN_FEHLGESCHLAGEN",
  },
  rightDrawer: {
    showMoreText: "Anzeigen",
    contactUs: "Contact us",
    findDealer: "Find a dealer",
  },
  fmSummary: {
    shortSummaryTitle1: "Kulturen",
    shortSummaryTitle2: "Erde",
    shortSummaryTitle3: "Lösung",
    shortSummaryTitle4: "Landwirtschaft",
    shortSummaryTitleGraphPage: "Maßgeschneidert",
    ourProducts: "Unsere Produkte",
    summary: "Gesammelte Daten",
    seeMoreProducts: "Weitere Multicote™-Produkte anzeigen",
    recipeCoatedElements: "Beschichtete Elemente",
    recipeUncoatedElements: "Unbeschichtete Elemente",
  },
  fmLeftMenu: {
    title: "MultiMatch",
    subTitle: "Maßgeschneiderte Planeten-\nErnährungsprogramme",
    menuLabels: {
      label0: "Shlomit Adary",
      label1: "Multicote Agri-Lösung",
      label2: "Multicote-Lösung",
      label3: "Gespeicherte Element",
      label4: "Über",
      label5: "Kontaktieren sie uns",
    },
    logout: "Ausloggen",
  },
  steps: {
    cropsDesktop: "Kulturen",
    cropsMobile: "Ihre Ernteeigenschaften",
    soilDesktop: "Erde",
    soilMobile: "Bodentemperaturen & Eigenschaften",
    resultsDesktop: "Ergebnisse",
    resultsMobile: "Ergebnisse",
    farmDesktop: "Landwirtschaft",
    farmMobile: "landwirtschaftliche Praxis",
    customizeDesktop: "Anpassen\n (Optional)",
    customizeMobile: "Stellen Sie Ihre eigene Mischung zusammen (optional)",
  },
  agriSolution: {
    npkAlert: "NPK is Different from Crop Demand:",
    title: "Multicote Agri-Lösung",
    selectCropLabel: "Wählen Sie eine Kultur",
    expectedYieldLabel: "Erwarteter Ertrag",
    plotSizeLabel: "Grundstücksgröße",
    plantingDateLabel: "Pflanzdatum",
    finalHarvestExpectedDate: "Erwartetes Erntedatum",
    selectPlotLocationLabel: "Grundstücksort wählen",
    selectPlotLocationNote: "Sei so genau wie möglich. Dies hilft bei der Auswertung der Klimadaten.",
    selectArea: "oder wählen Sie einen Ort aus",
    selectOrAddNew: "Aus der Liste auswählen oder neu hinzufügen",
    onTheMap: "auf der Karte",
    select: "Auswählen",
    selectSoilLabel: "Bodentemperaturen & Eigenschaften",
    waterRegime: {
      title: "Wasserregime auswählen",
      description: "Wie sind die Niederschlagsbedingungen in der Gegend?",
      sliderMarks: {
        "1": "trocken",
        "2": "halbtrocken",
        "3": "halbtropisch",
        "4": "tropisch",
      },
    },
    soilType: {
      title: "Bodenart auswählen",
      description: "Welche Bodenart hat das Grundstück?",
      sliderMarks: {
        "1": "Sand, lehmiger Sand",
        "2": "Mittel sandig",
        "3": "Schlick, schluffiger Lehm, schluffiger Ton",
        "4": "Lehm und Ton bestehenden, Ton",
      },
    },
    soilWarning:
      "Der Nährstoffbedarf richtet sich nach dem zu erwartenden Ertrag. Ein Multicote-Düngeprogramm ist darauf ausgelegt: alle Makronährstoffe zu ersetzen: die die Ernte entfernt. Der Boden wird als Puffer betrachtet und der Nährstoffgehalt des Bodens wird nicht berücksichtigt. Es ist jedoch eine gute landwirtschaftliche Praxis: alle 2 bis 3 Jahre Bodenproben zu nehmen und die erforderlichen Verbesserungsmittel gemäß der Bodenanalyse anzuwenden. Dadurch wird sichergestellt: dass die Bodenfruchtbarkeit im Laufe der Zeit erhalten und verbessert wird.",
  },
  fmDescriptionSnippet: {
    title: "Willkommen beim Multicote-Lösungsrechner",
    description:
      "Eine Cloud-basierte Software: mit der Sie in wenigen einfachen Schritten Ihre eigene maßgeschneiderte Lösung für Dünger mit verzögerter Freisetzung (CRF) für einzelne oder Unternehmenszüchter erstellen können.",
  },
  fmDropdownWithImg: { title: "Wählen Sie Ihre Ernte" },
  back: "Zurück",
  fmRecommendedProduct: {
    volume: "Empfohlenes Auftragsvolumen",
    method: "Anwendungsverfahren",
    link: "Klicken Sie hier: um ein freigegebene Diagramm zu erhalten",
  },
  pageStep1: {
    soilTemp: "Bodentemperatur auswählen",
    change: "Änderung",
    note: "Bitte wählen Sie Ihre Ernte aus der Liste aus und geben Sie Ihren erwarteten Ertrag: das Pflanzdatum und das endgültige Erntedatum ein.",
    cfpTitle: "Carbon & Environmental footprint",
    cfpDesc: "assessment tool is now included in MultiMatch to help you improve your environmental impact",
    cfpButton: "Read More",
  },
  fertilizationPopup: {
    title: "Düngung Nährstoffanwendung",
    subTitle: "Kennen Sie Ihren aktuellen Gesamtnährstoffgehalt bei Ihrer derzeitigen Düngungspraxis?",
    thirdTitle: "Wählen Sie unten `Ich weiß` aus: um Ihre neue benutzerdefinierte Formel zu berechnen",
    iKnow: "Ich weiss",
    iDontKnow: "Ich weiß nicht",
    next: "Nächstes",
  },
  saveProcessPopup: {
    title: "Diesen Vorgang speichern",
    subTitle: "Wir haben festgestellt: dass Ihr Vorgang nicht gespeichert wurde. Möchten Sie fortfahren?",
    dontShowThisMessage: "Dies nicht wieder anzeigen",
    noThanks: "Nein danke",
    save: "Speichern",
  },
  clearStepPopup: {
    title: "Diesen Schritt löschen",
    subTitle: "Sind Sie sicher: dass Sie Ihre Daten aus diesem Schritt löschen möchten?",
    dontShowThisMessage: "Dies nicht wieder anzeigen",
    noGoBack: "Zurückgehen",
    clear: "Meine Daten löschen",
  },
  deleteItemPopup: {
    title: "Element löschen",
    subTitle: "Sind Sie sicher: dass Sie dieses Element löschen möchten?",
    no: "Nein",
    yes: "Ja",
  },
  saveItemPopup: {
    title: "Lösung speichern",
    label1: "Lösungsname",
    label2: "Bereich",
    getBack: "Ich möchte: dass ein Agronom aus Haifa meine Auswahl überprüft und sich bitte bei mir meldet.",
    save: "Speichern",
    snackbar: "Element gespeichert",
  },
  pageStep4: {
    title: "landwirtschaftliche Praxis",
    table: {
      nutrients: "Nährstoffe",
      nutrientsUnit: "(Kg/Ha)",
      label1: "Bauernpraxis",
      label2: "Pflanzennachfrage",
      label3: "Gesparte Nährstoffe aus der Umwelt",
    },
    question: "Was ist Ihre Praxis?",
    questionDescription:
      "Wenn Sie bereits bestimmte Düngemittel verwenden: die normale Erträge bringen: geben Sie uns bitte die pro Saison ausgebrachte Gesamt-NPK an. Wir verwenden diese Raten: um die optimalen Multicote-Raten für Ihre benutzerdefinierte Formel zu berechnen.",
    fill: "Füllen Sie Ihre Praxis",
    buttomDescription:
      "Durch die Verwendung von Multicote wird die Nährstoffnutzungseffizienz der umhüllten Nährstoffe stark verbessert. Dadurch können wir die insgesamt ausgebrachten Nährstoffe reduzieren und damit die Verschmutzung des Grundwassers und den Aufbau unerwünschter Salzkonzentrationen im Boden reduzieren.",
    warningText1: "Wir empfehlen: sich an einen ... zu wenden",
    warningText2: "Haifa Professional Agronom oder Lieferant",
    warningText3: "um Ihre Auswahl zu bestätigen: bevor Sie sich bewerben.",
    clearThisStep: "Diesen Schritt löschen",
    cfpBanner: "Data of used application rates helps the system calculate carbon and environmental footprint",
    next: "Nächstes",
    save: "Speichern",
  },
  multicoteTable: { mesurmentUnit: " (%)" },
  mainInterests: { OFA: "Landwirtschaft im Freiland", N: "Gärtnerei" },
  metricMethods: { "1": "Metrisch", "2": "majestätisch" },
  specialties: {
    "1": "Gartenarbeit \\ Hobby",
    "2": "Erzeuger",
    "3": "Landwirtschaftlicher Lohnunternehmer",
    "4": "Landwirtschaftliche Ausbildung \\ Dienstleistungen",
    "5": "Handeln",
    "6": "Weitere",
  },
  PageReleaseChart: {
    greenMessage: {
      title1: "WIE BENUTZT MAN",
      description1: "Multicote-Produktmischungen immer im Wurzelbereich auftragen.",
      description2: "Für eine optimale Leistung muss es mit Erde oder Mulch bedeckt werden.",
      subTitle: "Bewährtes Verfahren:",
      description3:
        "Beim Säen in Reihe auftragen. Zweitbeste Vor dem Anbau gleichmäßig verteilen und die Multicote-Mischungen in das Saatbeet einarbeiten.",
      title2: "WENN",
      description4: "Während der Aussaat oder bei der Parzellenvorbereitung: aber nicht mehr als 2 Wochen vor der Aussaat.",
      title3: "WIE VIEL",
      description5:
        "Die Multicote-Technologie ist sicher in der Anwendung: aber stellen Sie am besten sicher: dass die Maschinen richtig kalibriert sind.",
      title4: "FREIGABE KURVE",
      description6: "Die Freisetzungskurve zeigt die Nährstofffreisetzung entsprechend der erwarteten Bodentemperatur",
      radioButtonLabel: "Wählen Sie ein Thema",
      shareUnsavedItem: "Entschuldigung: ungespeichertes Element kann nicht geteilt werden",
    },
    currentDayRemainingReleaseValues: {
      preValue: "Monat",
      postValue: "verbleibende NPK:",
      currentPrecentage: "Remaining NPK (Percentage):",
      Percentage: "(Percentage)",
    },
    sendToAgronomist: {
      preUserName: "Der Nutzer",
      preCrop: "plant eine Lösung für die Ernte",
      preYield: "mit erwartetem Ertrag von",
      preStartingDate: "Anfangsdatum:",
      preFinalDate: "Endgültiges Datum:",
      preSolutionName: "Lösung:",
      materialCode: "Material code:",
      preVolumeApplication: "Volumenanwendung",
    },
    warning: {
      description: "Zusätzliche Anwendung von Sekundär- und Mikroelementen wird erforderlich sein. Für eine vollständige Empfehlung",
      boldDescription: "kontaktieren Sie Ihren lokalen Haifa Agronomen oder Lieferant",
    },
    buttons: {
      downloadFile: "PDF herunterladen",
      sendToPro: "An Agronom senden",
      shareLink: {
        desktop: "Einen Link teilen",
        mobile: "Einen",
      },
    },
  },
  wideTable: {
    kodkod: { title1: "Materialfreigabe", title2: "nach Monat (Kg/Ha)" },
    sideLabel: { label1: "N (var)", label2: "P", label2_1: "O", label3: "K" },
    months: {
      month1: "Jan",
      month2: "Feb",
      month3: "Mär",
      month4: "Apr",
      month5: "Mai",
      month6: "Jun",
      month7: "Jul",
      month8: "Aug",
      month9: "Sep",
      month10: "Okt",
      month11: "Nov",
      month12: "Dez",
    },
    caroselHeader: { title: "Monatliche Freigabe (%)" },
    next: "Nächstes",
    back: "Zurück",
  },
  saveItemsPage: {
    title: "Gespeicherte Lösungen",
    inputPlaceholder: "Geben Sie eine Pflanzenart oder einen Bereich ein: um Ihre gespeicherten Mischungen zu finden",
    mobile_inputPlaceholder: "Geben Sie eine Pflanzenart oder ein Bereich ein",
    clearAll: "Alles löschen",
    loadMore: "Mehr laden",
    savedItemCard: {
      rename: "Umbenennen",
      delete: "Löschen",
      duplicate: "Duplikat",
      contact: "Kontakt",
      showTo: "Element dem Haifa-Agronomen zeigen",
    },
  },
  multicoteSolutionPage: {
    stepOne: {
      firstInput: "Mischung auswählen",
      secondInput: "Anfangsdatum",
      radioLabel1: "P2O5 K20",
      radioLabel2: "PK",
      selectTemperature: "Temperatur wählen",
      calculateButton: "Kalkulieren",
      setTempratureButton: "Temperaturen einstellen",
    },
    title: "Multicote-Lösung",
    changeCalculationSetting: "Berechnungseinstellung ändern",
    save: "Speichern",
    line: "Linie",
    bar: "Balken",
    graphCodCodTitle: "Materialfreigabe",
  },
  pageStep3: {
    carbonFootprintLoadingText: "Bitte schließen Sie dieses Fenster nicht",
    carbonFootprintDesc: "Bewertung des Umwelt- und Kohlenstoff-Fußabdrucks für den gesamten Anbauzyklus",
    carbonFootprintButtonText: "Rechnen Sie für mich!",
    subTitle: "Seine Empfehlung",
    customize: {
      bestSuit: "Am besten geeignete Formel",
      subDescription: "Wir haben diese Formel gefunden: die den Anforderungen Ihrer Ernte am besten entspricht.",
      title: "Wollen Sie die Formel anpassen?",
      secondSubDescription:
        "Sie können diese Formel entweder anpassen oder in wenigen einfachen Schritten Ihre eigene an Ihre örtlichen Bedingungen anpassen.",
      button: "Formel anpassen",
      topLink: "Diagramm freigeben",
    },
    bottomTitle: "Fertigformel",
    bottomDescriptionWithMatch: "Dies ist die am meisten empfohlene fertige Formel in der Nähe Ihrer Empfehlung",
    bottomDescriptionWithoutMatch:
      "Wir konnten keine passende Formel finden: die Ihren Pflanzenanforderungen: Boden- und Klimabedingungen entspricht",
    recommendedProduct: {
      description:
        "Unsere Empfehlung basiert ausschließlich auf dem Pflanzenbedarf an NPK: entsprechend dem bekannten Bedarf an diesen Nährstoffen. Die Anwendung von Sekundär- und Mikronährstoffen erfolgt gemäß der Bodenanalyse und den Anforderungen der Pflanzen.",
    },
    save: "Speichern",
    inSoil: "Im Boden",
    metric: "Kg/Ha",
    imperial: "ST/Morgen",
  },
  pageStep5: {
    title: "Stellen Sie Ihre eigene Mischung zusammen",
    updateButton: "Berechnung von  N: P: K aktualisieren",
    recipeValidationError: "Rezept muss mindestens 1 beschichtetes Material enthalten: maximal 6 Elementen insgesamt",
    save: "Speichern",
    bestSolution: "Beste Lösung",
    subTitle1: "Insgesamt bis zu 6 Materialien auswählen",
    coated: "beschichtet",
    uncoated: "unbeschichtet",
    completePercentage: "Abgeschlossener Prozentsatz Ihrer Multicote-Mischung:",
    missing: "fehlen",
    clear: "Diesen Schritt löschen",
    continueButton: "Weiter zum freigegebenem Diagramm",
    bottomDrawer: {
      savedItem: "Gespeicherte Element",
      rename: "Umbenennen",
      delete: "Löschen",
      reset: "Zurücksetzen",
      update: "Aktualisieren",
    },
    uncoatedHelperText: "",
    updateCard: {
      leftSpan: "N, P, K wird durch Ihre Materialauswahl berechnet:",
      errorMessage: {
        missingWord: "Increase",
        extraWord: "Decrease",
        rightPart: "% for calculation",
      },
    },
  },
  userAreaPage: {
    title: "Mein Profil",
    tab1: "Benutzerprofil",
    tab2: "Meine Rohstoffbank",
    inputLabel1: "Vollständiger Name",
    inputLabel2: "Land",
    inputLabel3: "Email",
    inputLabel4: "Ihr Hauptinteresse",
    inputLabel5: "Fachkenntnisse (Optional)",
    button: "Aktualisieren",
    inputSecondPage: "unbeschichtet",
    messages: { success: "Profil erfolgreich aktualisiert" },
    uncoatedInputHelperText: "",
  },
  contactUs: {
    title: "Eine Frage haben? Brauchen Sie Rücksprache?",
    secondTitle: "Danke für den Besuch unserer Plattform",
    description:
      "Wir helfen Ihnen gerne bei allen Fragen: die Sie möglicherweise haben: und würden gerne von Ihren Erfahrungen hören: damit wir unser Angebot weiter verbessern können.",
    inputLabel1: "Land",
    inputLabel2: "Region",
    inputLabel3: "Position",
    inputLabel4: "Wachstumsmethode",
    inputLabel5: "Handynummer",
    inputLabel6: "Bereichsgröße(ha)",
    inputLabel7: "Email-Addresse",
    inputLabel8: "Ihre Nachricht",
    back: "Zurück",
    send: "Schicken",
    messages: {
      success: "Danke für Ihre Email. Wir melden uns bald bei Ihnen.",
      invalidPhoneNumber: "Ungültige Handynummer",
    },
  },
  PDFfile: {
    mateData: {
      createdBy: "Erstellt von:",
      name: "Name:",
      location: "Standort:",
      phoneNumber: "Telefonnummer:",
      Date: "Datum:",
      Time: "Uhrzeit:",
    },
    summaryData: {
      nutrientsApplied: "Zugesetzte Nährstoffe:",
      collectedDataTitle: "Gesammelte Daten:",
      cropsTitle: "Ernte",
      cropProp: "Ernte",
      yieldProp: "Rendite:",
      plotSize: "Plot Size",
      plantingDateProp: "Pflanzdatum",
      harvestDateProp: "Erntedatum",
      soilTitle: "Erde",
      WaterRegimeProp: "Wasserregime",
      soilProp: "Erde",
      customizedTitle: "Maßgeschneidert",
      recipeCoatedTitle: "Beschichtete Elemente",
      recipeUncoatedTitle: "Unbeschichtete Elemente",
      recommended: "Empfohlen",
      MaterialCodeProp: "Materialnummer",
    },
    waver: {
      title: "WANKEN",
      body: {
        before: "Before using, the grower shall determine the suitability of the product for his intended use.",
        theGrower: "The grower assumes all risk and liability for consequential and incidental damages. This product",
        isSold: "is sold without warranty of any kind, expressed or implied, as to  its merchantability",
        orFitness: " or fitness for a particular purpose.",
        caution: "Caution: ",
        harmful: "Harmful is swallowed. Keep out of reach of children. Store under cool, dry conditions.",
      },
    },
    descriptionRecommended:
      "Unsere Empfehlung basiert ausschließlich auf dem Pflanzenbedarf an NPK: entsprechend dem bekannten\nBedarf an diesen Nährstoffen. Die Anwendung von Sekundär- und Mikronährstoffen erfolgt gemäß der\nBodenanalyse und den Anforderungen der Pflanzen.",
    howToUse: {
      title: "WIE BENUTZT MAN",
      body: {
        firstLine: "Multicote-Produktmischungen immer im Wurzelbereich auftragen.",
        secondLine: "For optimal performance, it must be covered with a few centimeters of soil",
        thirdLine: "or mulch.",
        fourthLinePartOne: "Best practice:",
        fourthLinePartTwo: "Apply in row while seeding.",
        fifthLinePartOne: "2nd best:",
        fifthLinePartTwo: "Spread evenly before cultivation and incorporate the Multicote™",
        fifthLinePartThree: "blends into the seedbed.",
        forOptimalPerformance: "For optimal performance, mix Multicote™ with potting soil before planting.",
        mixMulticote: " Mix Multicote™ with potting soil before planting.",
        secondBestPractice: "2nd best practice - Dibbling:",
        forLate: "for late application, make holes around the plant and apply ,Multicote™",
        evenly: "evenly, cover with soil.",
      },
    },
    when: {
      title: "WENN",
      body: {
        firstLine: "While seeding or at plot preparation, but not more than 2 weeks prior to ",
        secondLine: "planting. ",
      },
    },
    howMuch: {
      title: "WIE VIEL",
      body: {
        firstLine: "Multicote™ technology is safe for use, but for best practice make sure",
        secondLine: "machinery is correctly calibrated.",
      },
    },
    releaseCurve: {
      title: "FREIGABE KURVE",
      body: "Die Freisetzungskurve zeigt die Nährstofffreisetzung entsprechend der erwarteten Bodentemperatur",
    },
    nameOfFile: "Multicote™ - Unsere Lösung.pdf",
  },
  ShareEmail: {
    title: "Anleitungen",
    body: {
      please: "Bitte",
      find: "finden",
      attached: "angebracht",
      recommendation: "Empfehlung",
      Thank: "Danke",
      you: "Sie",
      Haifa: "Haifa",
      Group: "Gruppe",
    },
  },
  autoCompleteInput: {
    firstSpan: "Diese Werte sind ungültig",
    secondSpan: "max N, P, K ist 46, 54, 62",
    thirdSpan: "Maximale Summe ist 66",
    noOptions: "Keine Optionen",
  },
  sideMenu: {
    termsAndCondition: {
      title: "Geschäftsbedingungen",
      contentTitle: "Nutzungsbedingungen",
    },
    privacyPolicy: { title: "Datenschutzrichtlinie" },
    copyRightTitle: "Urheberrecht 2021 Haifa",
    poweredBy: "Bereitgestellt von",
  },
  cfpTable: {
    savingTitle: "Économie d'éq. CO2",
    reducedCo2: "Per",
    reducedCo2PerPlot: "Pro Parzelle",
    rating: {
      excellent: "Ausgezeichnet",
      worse: "Schlechter",
    },
    tableColumns: {
      envParams: "Umweltparameter",
      multiTech: "Multicote™-Technologie",
      tradTech: "Traditionelle Anwendung",
      performanceRating: "Multicote™ Technologie Leistung Bewertung",
      index: "Index",
    },
    tableRows: {
      carbonFootprint: {
        label: "Kohlenstoff-Fußabdruck",
        measureUnit: "kg CO2 Äq./Kg Erzeugnis",
      },
      nLeaching: {
        label: "N-Auswaschung",
        measureUnit: "kg NO3/Kg Erzeugnis",
      },
      nRunOff: {
        label: "N Abfluss",
        measureUnit: "kg NO3/Kg Erzeugnis",
      },
      nVolatilization: {
        label: "N-Verflüchtigung",
        measureUnit: "kg NH3/Kg Erzeugnis",
      },
      terrestrialEutrophication: {
        label: "Eutrophierung des Bodens",
        measureUnit: "kg P-Äq./Kg Erzeugnis",
      },
    },
    carbonBannerTitle: "Berechnung der Kohlenstoffeinsparung",
    carbonBannerText: "((Kohlenstoff-Fußabdruck der herkömmlichen Anwendung)/ha - (Kohlenstoff-Fußabdruck der Multicote™-Technologie)/ha) X Erwarteter Ertrag T/Ha)",
  },
};
export default texts;
